export type ComponentsDataState = Record<string, unknown>;